import * as React from 'react';
import { HTMLAttributes, Ref, forwardRef } from 'react';
import cn from 'classnames';

import '@mos-utils/css/lib/typography/Heading.css';

function Heading(
  { level, children, className, ...props }: Props,
  ref: Ref<HTMLHeadingElement>
) {
  return React.createElement(
    `h${level}`,
    {
      className: cn('mos-heading', `mos-heading_level_${level}`, className),
      ref,
      ...props
    },
    children
  );
}

interface Props extends HTMLAttributes<HTMLHeadingElement> {
  level: 1 | 2 | 3 | 4 | 5 | 6;
}

/**
 * @version ../package.json
 */
export default forwardRef(Heading);
